export const ItemAvatarSkeletonComponent = {
  templateUrl:
    'components/Skeletons/item-avatar-skeleton/item-avatar-skeleton.html',
};
